import React from 'react'
import styles from "../style";
import { Footer,Sermain,WhyC,Swo, SEO} from '../components';

const servicesStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'Software Development Services',
  provider: {
    '@type': 'Organization',
    name: 'Software India',
    url: 'https://www.softwareindia.com',
  },
  areaServed: {
    '@type': 'Country',
    name: 'India',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'Software Development Services',
    itemListElement: [
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Web Development',
          description: 'Custom web development services with responsive design and SEO optimization',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Branding',
          description: 'Complete branding solutions including visual identity and brand strategy',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Video Editing',
          description: 'Professional video editing and production services',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Domain Management',
          description: 'Domain registration, DNS configuration, and domain management services',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Security Services',
          description: 'Comprehensive cybersecurity solutions and threat detection',
        },
      },
      {
        '@type': 'Offer',
        itemOffered: {
          '@type': 'Service',
          name: 'Updates and Management',
          description: 'Website maintenance, updates, and ongoing management services',
        },
      },
    ],
  },
};

export default function Services(){
  return (
    <>
      <SEO
        title="Our Services | Web Development, Branding, Video Editing | Software India"
        description="Comprehensive software development services by Software India. Expert web development, branding, video editing, domain management, security, and maintenance services. Cost-effective pricing with guaranteed deadline completion."
        keywords="web development services, branding services, video editing services, domain management, cybersecurity services, website maintenance, software development services, UI/UX design services, responsive web design, custom website development, India software services"
        url="https://www.softwareindia.com/services"
        canonical="https://www.softwareindia.com/services"
        structuredData={servicesStructuredData}
      />
    <div>
       <div className={`bg-[#00040F] ${styles.paddingX} ${styles.flexCenter}`}>
        <div className={`${styles.boxWidth}`}>
          <Sermain/>
         < WhyC/>  
        < Swo/>
          <Footer/>

        </div>
      </div>
    </div>
    </>
  )
}


